//
// Copyright (c) 2025 Emplifi, Inc.
//

// @ts-ignore
import i18next from "i18n/i18n";
import { ButtonView, Plugin } from "ckeditor5";

// @ts-ignore
import "./css/collapsibleSectionUi.css";

// @ts-ignore
import collapsibleSectionIcon from "img/svg/collapsibleSection.svg";

export default class CollapsibleSectionUi extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "CollapsibleSectionUi";
  }

  init() {
    this._addToolbarButtons();
  }

  private _addToolbarButtons() {
    this.editor.ui.componentFactory.add("collapsibleSection", (locale) => {
      const command = this.editor.commands.get("insertCollapsibleSection");
      const button = new ButtonView(locale);
      button.set({
        isEnabled: true,
        label: i18next.t("ckeditor.collapsibleSection.buttonName"),
        icon: collapsibleSectionIcon,
        tooltip: true,
      });
      if (command) {
        button.bind("isEnabled").to(command);
      }
      this.listenTo(button, "execute", () => this.editor.execute("insertCollapsibleSection"));
      return button;
    });
  }
}
